import React from 'react';
import { CheckCircle, BookOpen, Clock, Award, Link as LinkIcon } from 'lucide-react';
import './Certifications.css';

const OFFICIAL_CERTS = [
  // ... (Your data remains exactly the same)
  {
    id: 1,
    title: "AWS Certified Cloud Practitioner (CLF-C02)",
    issuer: "Amazon Web Services",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
    type: "certification",
    status: "verified",
    desc: "Cloud security fundamentals, Shared Responsibility Model, IAM, DevSecOps alignment.",
    tags: ["AWS", "IAM", "Cloud Security"],
    certLink: null, 
    link: "https://aws.amazon.com/certification/certified-cloud-practitioner/"
  },
  {
    id: 2,
    title: "Microsoft Certified: Security Operations Analyst (SC-200)",
    issuer: "Microsoft",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    type: "certification",
    status: "in_progress",
    desc: "Threat mitigation using Microsoft 365 Defender, Defender for Cloud, and Microsoft Sentinel (KQL).",
    tags: ["SC-200", "Sentinel", "KQL", "Defender"],
    certLink: null,
    link: "https://learn.microsoft.com/en-us/credentials/certifications/exams/sc-200/"
  },
  {
    id: 3,
    title: "Microsoft Certified: Security, Compliance & Identity (SC-900)",
    issuer: "Microsoft",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    type: "certification",
    status: "verified",
    desc: "Identity & Access Management (IAM), Zero Trust principles, Sentinel, and Compliance.",
    tags: ["SC-900", "Zero Trust", "Azure"],
    certLink: null,
    link: "https://learn.microsoft.com/en-us/credentials/certifications/exams/sc-900/"
  },
  {
    id: 4,
    title: "Google Cybersecurity Professional Certificate",
    issuer: "Google & Coursera",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
    type: "certification",
    status: "verified",
    desc: "Hands-on labs in Python, Linux, SQL, SIEM tools, and IDS for SOC analyst roles.",
    tags: ["Python", "Linux", "SQL", "SIEM"],
    certLink: "https://coursera.org/share/60701be34a9c75cc63255fb2e7bc72a5",
    link: "https://www.coursera.org/professional-certificates/google-cybersecurity"
  }
];

const TRAINING_COURSES = [
  // ... (Your data remains exactly the same)
  {
    id: 101,
    title: "Application Security – The Complete Guide",
    issuer: "Udemy (Derek Fisher)",
    type: "course",
    tags: ["AppSec", "SDLC"],
    link: "https://www.udemy.com/share/103oSg3@ivjhe1f9YlHgNCulJpJFTEvorRo3q621mwJoLomAR567sc-Dg4XlEdILwOf-8FaY0g==/",
    certLink: "https://www.udemy.com/certificate/UC-380aaab6-b6d1-4b34-9317-3737be15f9b5/"
  },
  {
    id: 102,
    title: "Master Cyber Security: Advanced VAPT",
    issuer: "Udemy",
    type: "course",
    tags: ["VAPT", "Burp Suite"],
    link: "https://www.udemy.com/share/10bASD3@r9svLKpln5EBdvvkeVKHp6MZyPKL7NiIp3yeu_GhrnXSTO8XO5DmDGmrK9wGKy05iw==/",
    certLink: "https://www.udemy.com/certificate/UC-62c4873f-de46-4307-8b83-c0be9609986f/" 
  },
  {
    id: 104,
    title: "Introduction to Generative AI",
    issuer: "Google Cloud Skills Boost",
    type: "course",
    tags: ["GenAI", "LLM"],
    link: "https://www.coursera.org/learn/introduction-to-generative-ai",
    certLink: "https://coursera.org/share/ab515580eec08352dc05781d809f1c03"
  },
  {
    id: 105,
    title: "Career Essentials in Generative AI",
    issuer: "Microsoft & LinkedIn",
    type: "course",
    tags: ["AI Ethics", "Copilot"],
    link: "https://www.linkedin.com/learning/paths/career-essentials-in-generative-ai-by-microsoft-and-linkedin",
    certLink: "https://www.linkedin.com/learning/certificates/3f64f41a8f3553c5372adcf3227f3ce4197dbb9a62f8cae99d6d5ab33c5b2fbc?trk=share_certificate"
  },
  {
    id: 106,
    title: "Prompt Engineering: How to Talk to the AIs",
    issuer: "LinkedIn Learning",
    type: "course",
    tags: ["Prompt Eng", "GPT-4"],
    link: "https://www.linkedin.com/learning/prompt-engineering-how-to-talk-to-the-ais",
    certLink: "https://www.linkedin.com/learning/certificates/ac3a0c8361a59d8d84ec83c3243074f1798ea43ae1acaa5b1b3512ae983049d9?trk=share_certificate"
  }
];

const Certifications = () => {
  return (
    <section className="certifications-section" id="certifications">
      <div className="certifications-container">
        <div className="vault-section">
            <div className="section-header">
                <h2 className="section-title">CREDENTIALS_VAULT</h2>
                <p className="section-subtitle">Verified Clearances & Skill Acquisitions</p>
            </div>

            <h3 className="subsection-label">:: GLOBAL_CERTIFICATIONS</h3>
            <div className="certs-grid">
                {OFFICIAL_CERTS.map((cert) => (
                    <div key={cert.id} className="cert-card">
                        
                        {/* 🟢 NEW: Matrix Noise Layer */}
                        <div className="matrix-noise"></div>
                        
                        <div className="scanner-line"></div>
                        <div className="cert-header">
                            <div className="cert-logo-box">
                                <img src={cert.logo} alt={cert.issuer} className="cert-logo-img" />
                            </div>
                            <div 
                              className="cert-status"
                              style={{ 
                                color: cert.status === 'in_progress' ? '#FFAA00' : 'var(--accent-green)',
                                borderColor: cert.status === 'in_progress' ? '#FFAA00' : 'var(--accent-green)'
                              }}
                            >
                                {cert.status === 'in_progress' ? (
                                  <>
                                    <Clock size={12} />
                                    <span>IN PROGRESS</span>
                                  </>
                                ) : (
                                  <>
                                    <CheckCircle size={12} />
                                    <span>VERIFIED</span>
                                  </>
                                )}
                            </div>
                        </div>

                        <div className="cert-body">
                            <h3 className="cert-title">{cert.title}</h3>
                            <div className="cert-issuer">{cert.issuer}</div>
                            <p className="cert-desc">{cert.desc}</p>
                            <div className="cert-tags">
                                {cert.tags.map((tag, i) => (
                                    <span key={i} className="cert-tag">{tag}</span>
                                ))}
                            </div>
                        </div>
                        
                        <div className="card-actions-row">
                            {cert.link && (
                                <a href={cert.link} target="_blank" rel="noopener noreferrer" className="action-btn secondary">
                                    <LinkIcon size={12} /> COURSE
                                </a>
                            )}
                            {cert.certLink && (
                                <a href={cert.certLink} target="_blank" rel="noopener noreferrer" className="action-btn primary">
                                    <Award size={12} /> CREDENTIAL
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div className="training-wrapper">
              <h3 className="subsection-label">:: SPECIALIZED_TRAINING_&_COURSES</h3>
              <div className="training-grid">
                  {TRAINING_COURSES.map((course) => (
                      <div key={course.id} className="training-card">
                          
                          {/* 🟢 NEW: Matrix Noise Layer */}
                          <div className="matrix-noise"></div>

                          <div className="training-header">
                            <BookOpen size={16} className="training-icon" />
                            <span className="training-issuer">{course.issuer}</span>
                          </div>
                          <h4 className="training-title">{course.title}</h4>
                          <div className="cert-tags mini-tags">
                              {course.tags.map((tag, i) => (
                                  <span key={i} className="cert-tag">{tag}</span>
                              ))}
                          </div>
                          
                          <div className="card-actions-row small-actions">
                             {course.link && (
                                <a href={course.link} target="_blank" rel="noopener noreferrer" className="action-btn secondary small">
                                    <LinkIcon size={10} /> COURSE
                                </a>
                             )}
                             {course.certLink && (
                                <a href={course.certLink} target="_blank" rel="noopener noreferrer" className="action-btn primary small">
                                    <CheckCircle size={10} /> CERT
                                </a>
                             )}
                          </div>
                      </div>
                  ))}
              </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;